import { defineComponent as _defineComponent } from 'vue'
import { PaginatedQuery, FeeEntry, feeStateLabels, CustomFeeReason } from 'ah-api-gateways';
import { feeEntryTableFields } from '../../models/feesTableFields';
import { PaginatedTable } from 'ah-common-lib/src/common/components';
import FeeTransactionDetails from './FeeTransactionDetails.vue';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { formatDate } from 'ah-common-lib/src/helpers/time';
import { computed, onBeforeMount, PropType, ref } from 'vue';
import { useAhTradesState } from '../..';
import { defineUseManagedListingProps, useManagedListing, UseManagedListingEmits } from 'ah-common-lib/src/listing';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';

interface FeeEntryEmits extends UseManagedListingEmits<FeeEntry> {}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeesListing',
  props: {
  config: {
    type: Object as PropType<{ tableFields: any[] }>,
    required: false,
    default: () => ({ tableFields: feeEntryTableFields }),
  },
  /**
   * Wallet ID for wallet outgoing/incoming reference
   *
   * As all fees come/go from/to clients/partners GBP wallet, a single `walletId` can be used to determine
   * whether these fees are outgoing or incoming, using the `fromWalletId` property
   */
  referenceWalletId: {
    type: String,
    required: true,
  },
  ...defineUseManagedListingProps<FeeEntry>(),
},
  setup(__props, { expose, emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props;



const tradeState = useAhTradesState();

const requestManager = useRequestManager().manager;

const paginatedTable = ref<InstanceType<typeof PaginatedTable> | null>(null);

const onBehalfOfClient = useOnBehalfOf();



const managedListing = useManagedListing<FeeEntry>({
  loadDataRequest(query: PaginatedQuery) {
    const filter: PaginatedQuery = {
      ...query,
      fromWalletId: props.referenceWalletId,
    };
    return tradeState.services.wallet.listFeeEntries(filter);
  },
  emit,
  props,
  fields: computed(() => props.config.tableFields),
  reqManager: requestManager,
});

function getAmount(item: FeeEntry) {
  return item.fromWalletId === props.referenceWalletId ? -item.amount : item.amount;
}

function getFeeStateLabels(item: FeeEntry) {
  return feeStateLabels[item.state];
}

const customFeeReasonOptions = ref<CustomFeeReason[]>([]);

function getCustomFeeReasons() {
  requestManager
    .sameOrCancelAndNew('getCustomFeeReasons', tradeState.services.fees.getCustomFeeReasons())
    .subscribe((getCustomFeeReasonsResponse: CustomFeeReason[]) => {
      customFeeReasonOptions.value = getCustomFeeReasonsResponse;
    });
}

function getCustomFeeReasonDescription(feeReason: string): string {
  const reason = customFeeReasonOptions.value.find((r) => r.value === feeReason);
  return reason ? reason.description : '';
}

onBeforeMount(() => {
  getCustomFeeReasons();
});

expose({ loadData: managedListing.loadData });

return { __sfc: true,props, tradeState, requestManager, paginatedTable, onBehalfOfClient, emit, managedListing, getAmount, getFeeStateLabels, customFeeReasonOptions, getCustomFeeReasons, getCustomFeeReasonDescription, PaginatedTable, FeeTransactionDetails, formatCurrencyValue, formatDate }
}

})